import React from 'react'
import { Skeleton, Typography, Form, Input, Transfer, Button, Row, Col, Divider } from 'antd'
import { FormComponent, BaseFormComponentProps } from '../../BaseComponent'
import IQuestionTemplate from '../../../interfaces/IQuestionTemplate'
import IQuestion from '../../../interfaces/IQuestion'

type QuestionTemplateProps = BaseFormComponentProps & {
  uuid?: string,
  data?: IQuestionTemplate,
  loading?: boolean,
  contentLoading: boolean,

  history: any,

  questions: Array<IQuestion> | null,

  loadQuestions?: Function,

  loadQuestionTemplate?: Function,

  dispatchSave: Function
}

export default class QuestionTemplate extends FormComponent<QuestionTemplateProps> {

  static defaultProps = {
    loading: false,
    contentLoading: true
  }

  state = {
    loaded: false,
    saving: false,
    selectedQuestions: [] as Array<string>
  }

  static getDerivedStateFromProps(props: any, state: any) {
    // After all of our requeriments has been loaded, we can load our entity fully
    if (!state.loaded && !props.loading && !props.data && !props.contentLoading) {
      // Do we have what is needed to make the request?
      if (props.uuid && props.loadQuestionTemplate) {
        props.loadQuestionTemplate({
          search: {
            uuid: props.uuid,
            questions: {
              with: true
            }
          },
          options: {
            "_force_ids": true
          }
        })
      }
    }

    // Load state data
    if (props.data && !state.loaded) {
      const { questions } = props.data

      if (questions) {
        state.selectedQuestions = questions.filter((question: any) => question.question_id).map((question: any) => question.question_id.toString())
      }

      state.loaded = true
    }

    // Saved
    if (state.saving && !props.loading) {
      state.saving = false
      props.history.replace('/organization/question-template')
    }

    return state
  }

  componentDidMount() {
    const { loadQuestions } = this.props

    if (loadQuestions) {
      loadQuestions({
        search: {
          group: {
            with: true
          }
        },
        options: {
          limit:9999,
          _force_ids: true
        }
      })
    }
  }

  handleQuestionSelection = (targetKeys: any, direction: any, moveKeys: any) => {
    this.setState({
      selectedQuestions: targetKeys
    })
  }

  handleSave = (values: any) => {
    const { uuid, dispatchSave } = this.props
    const { selectedQuestions } = this.state

    const payload = {
      ...values,
      uuid,
      questions: selectedQuestions.map(questionId => Number(questionId))
    }

    dispatchSave(payload)
    this.setState({
      saving: true
    })
  }

  render() {
    const { uuid, contentLoading, loading, questions, data } = this.props
    const { loaded, selectedQuestions } = this.state
    const values = {
      description: '',
      ...data || {}
    }

    if (contentLoading || (uuid && !loaded)) {
      return <Skeleton />
    }

    const questionsOptions = questions?.map(question => {
      return {
        key: question.id?.toString(),
        title: question.group?.name,
        description: question.ask,
        chosen: selectedQuestions.includes(question.id?.toString() || '')
      } as any
    })

    return (
      <Form
        name="question_template"
        initialValues={values}
        layout="vertical"
        onFinish={this.handleSave}
      >
        <Row gutter={24}>
          <Col xs={24} sm={12} md={12}>
            <Form.Item
              label="Name"
              name="name"
              rules={[
                {
                  required: true,
                  message: 'Missing a name'
                }
              ]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={12}>
            <Form.Item
              label="Description"
              name="description"
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={24}>
          <Col xs={24} sm={12} md={12}>
            <Typography.Title level={5}>Questions library</Typography.Title>
          </Col>
          <Col xs={24} sm={12} md={12}>
            <Typography.Title level={5}>Questions in this template</Typography.Title>
          </Col>
        </Row>
        
        <Transfer
          className="shelter-transfer"
          dataSource={questionsOptions}
          targetKeys={selectedQuestions}
          render={(record: any) => (
            <>
              <Typography.Text strong style={{fontSize: 12}}>{record.title} - </Typography.Text>
              <Typography.Text style={{fontSize: 12}}>{record.description}</Typography.Text>
            </>
          )}
          onChange={this.handleQuestionSelection}
        />

        <Divider />

        <Form.Item style={{ marginTop: 10 }}>
          <Button type="primary" htmlType="submit" loading={loading} size="large" ref={(refs) => this.actionRefs.save = refs} block>
            Save
          </Button>
        </Form.Item>
      </Form>
    )
  }
}
